import { computed } from 'mobx';

export default class SurveyModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.updateFromJson(item);
  }

  @computed get asJson() {
    return {
      id: +this.id,
      date_created: this.date_created,
      date_visited: this.date_visited,
      station_id: this.station_id,
      work_order_id: this.work_order_id,
      ticket_id: this.ticket_id,
      survey_template_id: this.survey_template_id,
      creator_user_id: this.creator_user_id,
      visitor_user_id: this.visitor_user_id,
      responses: this.responses || [],
      images: this.images || []
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.date_created = json.date_created;
    this.date_visited = json.date_visited;
    this.station_id = json.station_id;
    this.work_order_id = json.work_order_id;
    this.ticket_id = json.ticket_id;
    this.survey_template_id = json.survey_template_id;
    this.creator_user_id = json.creator_user_id;
    this.visitor_user_id = json.visitor_user_id;
    this.responses = json.responses || [];
    this.images = json.images || [];
  }
}



// WEBPACK FOOTER //
// ./src/models/Maintenance/Survey/SurveyModel.js